import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar, { SIDEBAR_EXPANDED_W } from './Sidebar';

const AppShell: React.FC = () => {
  const [sidebarWidth, setSidebarWidth] = useState(SIDEBAR_EXPANDED_W);

  return (
    <div className="min-h-screen text-on-surface font-body antialiased" style={{ background: '#f5f6fa' }}>
      <Header />
      <Sidebar onWidthChange={setSidebarWidth} />
      <div
        className="hidden md:block transition-all duration-200"
        style={{ paddingLeft: sidebarWidth }}
      >
        <main className="relative pt-16 min-h-screen w-full px-gutter-normal py-space-base" style={{ background: '#f5f6fa' }}>
          <Outlet />
        </main>
      </div>
      {/* Mobile: no sidebar offset */}
      <div className="md:hidden">
        <main className="relative pt-16 min-h-screen w-full px-gutter-normal py-space-base" style={{ background: '#f5f6fa' }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AppShell;
